import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';
import Popup from './components/Popup';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import BrandSection from './components/BrandSection';
import EnvironmentSection from './components/EnvironmentSection';
import PremiumSection from './components/PremiumSection';
import ComplexSection from './components/ComplexSection';
import CommunitySection from './components/CommunitySection';
import UnitSection from './components/UnitSection';
import RegisterSection from './components/RegisterSection';
import LocationSection from './components/LocationSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Popup />
      <Navbar />
      <main>
        <div id="top">
          <HeroSection />
        </div>
        <OverviewSection />
        <BrandSection />
        <EnvironmentSection />
        <PremiumSection />
        <ComplexSection />
        <CommunitySection />
        <UnitSection />
        <RegisterSection />
        <LocationSection />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}